__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "sid-fe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@securitize/domain", "2.43.0", () => (Promise.all([__webpack_require__.e(9471), __webpack_require__.e(4561)]).then(() => (() => (__webpack_require__(745))))));
			register("@securitize/reactjs-mfe", "0.34.0", () => (Promise.all([__webpack_require__.e(3140), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(3140))))));
			register("@securitize/reactjs-sid-utils", "0.5.3", () => (__webpack_require__.e(3850).then(() => (() => (__webpack_require__(3850))))));
			register("@securitize/reactjs-whm", "1.27.0", () => (Promise.all([__webpack_require__.e(39), __webpack_require__.e(6178), __webpack_require__.e(5429), __webpack_require__.e(7432), __webpack_require__.e(881), __webpack_require__.e(710), __webpack_require__.e(7334), __webpack_require__.e(4934), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(881))))));
			register("@tanstack/react-query", "5.54.1", () => (Promise.all([__webpack_require__.e(4653), __webpack_require__.e(710), __webpack_require__.e(2960)]).then(() => (() => (__webpack_require__(4653))))));
			register("dompurify", "2.5.7", () => (__webpack_require__.e(6213).then(() => (() => (__webpack_require__(6213))))));
			register("formik", "2.4.6", () => (Promise.all([__webpack_require__.e(3892), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(3892))))));
			register("html-react-parser", "5.1.18", () => (Promise.all([__webpack_require__.e(229), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(229))))));
			register("i18n-iso-countries", "7.11.3", () => (__webpack_require__.e(1331).then(() => (() => (__webpack_require__(1331))))));
			register("react-copy-to-clipboard", "5.1.0", () => (Promise.all([__webpack_require__.e(710), __webpack_require__.e(9095)]).then(() => (() => (__webpack_require__(1476))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(7950), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "6.26.1", () => (Promise.all([__webpack_require__.e(1387), __webpack_require__.e(5475), __webpack_require__.e(710), __webpack_require__.e(7334), __webpack_require__.e(6061)]).then(() => (() => (__webpack_require__(5475))))));
			register("react-router", "6.26.1", () => (Promise.all([__webpack_require__.e(1387), __webpack_require__.e(3216), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(3216))))));
			register("react-timer-hook", "3.0.8", () => (Promise.all([__webpack_require__.e(710), __webpack_require__.e(4701)]).then(() => (() => (__webpack_require__(4701))))));
			register("react-transition-group", "4.4.5", () => (Promise.all([__webpack_require__.e(3330), __webpack_require__.e(710), __webpack_require__.e(7334), __webpack_require__.e(3716)]).then(() => (() => (__webpack_require__(3330))))));
			register("react", "18.3.1", () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(5043))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(6453).then(() => (() => (__webpack_require__(6453))))));
			register("yup", "1.4.0", () => (__webpack_require__.e(899).then(() => (() => (__webpack_require__(899))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};